"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiometricsUnbindSession = void 0;
const AccountService_1 = require("../AccountService");
const BasePasskeySession_1 = require("./BasePasskeySession");
class BiometricsUnbindSession extends BasePasskeySession_1.BasePasskeySession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.unbind_biometric_key);
    }
    start(bio_device_id, txn_id, ext) {
        super.startSession((mfaParams) => {
            return AccountService_1.AccountService.unbindBiometrics({ bio_device_id, txn_id: mfaParams.txn_id });
        }, txn_id, ext);
    }
}
exports.BiometricsUnbindSession = BiometricsUnbindSession;
